import React, { useEffect, useState } from "react";
import { Col, Form, Input, Row } from "antd";
import { useNavigate, useParams } from "react-router-dom";
import HeadingBack from "../../component/HeadingBack";
import { ValidateEmail, ValidatePhone } from "../../utils/validation";
import {
  addOrganization,
  fetchOrganizationById,
  updateOrganization,
} from "../../redux/Services/OrganizationServices";
import LoadingButton from "../../component/LoadingButton";
import { useAsyncAction } from "../../hooks/useAsyncAction";

// Same rule as the backend: first word of the name, letters/digits only
const idPrefix = (name = "") =>
  (name.trim().split(/\s+/)[0] || "").replace(/[^a-zA-Z0-9]/g, "").toUpperCase();

const OrganizationForm = () => {
  const { id } = useParams();
  const isEdit = !!id;
  const [form] = Form.useForm();
  const navigate = useNavigate();
  const [organizationId, setOrganizationId] = useState("");
  const name = Form.useWatch("Name", form);

  useEffect(() => {
    if (!isEdit) return;
    fetchOrganizationById(id).then((org) => {
      if (!org) return;
      setOrganizationId(org.OrganizationId);
      form.setFieldsValue({
        Name: org.Name,
        Email: org.Email,
        Mobile: org.Mobile,
        Address: org.Address,
      });
    });
  }, [id]);

  const [handleSubmit, saving] = useAsyncAction(async (values) => {
    const res = isEdit
      ? await updateOrganization(id, values)
      : await addOrganization(values);
    if (res) navigate("/organizations");
  });

  const prefix = idPrefix(name);

  return (
    <>
      <HeadingBack
        title={isEdit ? "Edit Organization" : "Add Organization"}
        subHeading={isEdit ? organizationId : ""}
      />
      <div className="p-20">
        <Form form={form} layout="vertical" autoComplete="off" onFinish={handleSubmit}>
          <Row gutter={[24, 0]}>
            <Col lg={12} xs={24}>
              <Form.Item
                label="Organization Name"
                name="Name"
                extra={
                  isEdit
                    ? `Organization ID: ${organizationId} (cannot be changed)`
                    : prefix
                    ? `Organization ID will be generated as ${prefix}_00X`
                    : "Organization ID is generated from the first word of the name"
                }
                rules={[
                  { required: true, whitespace: true, message: "Name is required" },
                  { max: 255, message: "Max 255 characters allowed" },
                ]}
              >
                <Input placeholder="e.g. Apollo Hospitals" />
              </Form.Item>
            </Col>
            <Col lg={12} xs={24}>
              <Form.Item label="Email" name="Email" rules={[{ validator: ValidateEmail }]}>
                <Input placeholder="Email" />
              </Form.Item>
            </Col>
          </Row>
          <Row gutter={[24, 0]}>
            <Col lg={12} xs={24}>
              <Form.Item label="Mobile" name="Mobile" rules={[{ validator: ValidatePhone }]}>
                <Input maxLength={10} placeholder="Mobile" />
              </Form.Item>
            </Col>
            <Col lg={12} xs={24}>
              <Form.Item label="Address" name="Address">
                <Input.TextArea rows={1} placeholder="Address" />
              </Form.Item>
            </Col>
          </Row>
          <div className="text-center">
            <LoadingButton type="submit" className="gradient-button w-auto" loading={saving}>
              {saving ? "Saving..." : "Submit"}
            </LoadingButton>
          </div>
        </Form>
      </div>
    </>
  );
};

export default OrganizationForm;
